import { NAVIGATION, PUBLISH_LATEST } from '../types';
import { error, success } from '../utils';

export let initialState = {
  publishLatest: {
    isLoading: false,
    isError: false,
  },
};

const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case PUBLISH_LATEST:
      return {
        ...state,
        publishLatest: {
          isLoading: true,
          isError: false,
        },
      };
    case success(PUBLISH_LATEST):
      return {
        ...state,
        publishLatest: {
          isLoading: false,
          isError: false,
        },
      };
    case error(PUBLISH_LATEST):
      return {
        ...state,
        publishLatest: {
          isLoading: false,
          isError: true,
        },
      };

    case NAVIGATION:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
